// The one mark for a checklist row's state (`ChecklistRowState`), shared by
// the editor's checklist card and the landing page's compatibility demo so
// the three states can never drift apart:
//   - done:       green check
//   - suggestion: amber dash (works as is, better with it)
//   - blocking:   red cross (the setup cannot work until it is fixed)
// A status readout, so it spends status hues and nothing else
// (AGENTS.md "Status-readout rule").

import { Check, Minus, X, type LucideIcon } from 'lucide-react';
import type { ChecklistRowState } from '@roomtreatment/av-compat';

const MARK: Record<ChecklistRowState, { Icon: LucideIcon; hue: string }> = {
  done: { Icon: Check, hue: 'var(--rt-ok)' },
  suggestion: { Icon: Minus, hue: 'var(--rt-warn)' },
  blocking: { Icon: X, hue: 'var(--rt-danger)' },
};

/** The fill hue for a state, for anything that must match the mark
 *  (the card's segmented progress bar). */
export function checklistStateHue(state: ChecklistRowState): string {
  return MARK[state].hue;
}

export default function ChecklistMark({
  state, className = '', iconClassName = 'h-4 w-4',
}: {
  state: ChecklistRowState;
  /** Size and placement of the round mark, e.g. `h-7 w-7`. */
  className?: string;
  iconClassName?: string;
}) {
  const { Icon, hue } = MARK[state];
  return (
    <span
      data-mark={state}
      className={`flex shrink-0 items-center justify-center rounded-full ${className}`}
      style={{ background: hue }}
    >
      <Icon className={iconClassName} style={{ color: 'var(--rt-button-label)' }} strokeWidth={3} aria-hidden />
    </span>
  );
}
